<template>
  <div class="container">
    <el-dialog
      title="券码核销"
      :visible.sync="dialogShow"
      width="1300px"
      @open="handleDialogOpen"
    >
      <el-table
        :data="tableData"
        size="small"
        border
        v-loading="tableLoading"
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="券码ID"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="券码名称"
          align="center"
        ></el-table-column>
        <el-table-column label="券码类型" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.sonType === 1">接机券</span>
            <span v-else-if="scope.row.sonType === 2">送机券</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="wechatNickName"
          label="用户昵称"
          align="center"
        ></el-table-column>
        <el-table-column label="券码有效期" align="center" width="320">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime }} 至 {{ scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="券码状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 1" type="success">未使用</el-tag>
            <el-tag v-else-if="scope.row.state === 2" type="info"
              >已使用</el-tag
            >
            <el-tag v-else-if="scope.row.state === 9" type="danger"
              >已过期</el-tag
            >
            <el-tag v-else type="warning">未知 ({{ scope.row.state }})</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state === 1"
              type="text"
              size="small"
              @click="handleVerify(scope.row)"
              >核销</el-button
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-wrap" style="margin-top: 20px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pointsItemsRoll, pointsItemsRollUse } from "@/common/api.js";
export default {
  name: "verification-sheet",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleDialogOpen() {
      this.page.current = 1;
      this.page.size = 10;
      this.getPointsItemsRoll();
    },
    getPointsItemsRoll() {
      console.log("this.userId", this.userId);

      this.tableLoading = true;
      let params = {
        type: 2,
        userId: this.userId,
        pageNum: this.page.current,
        pageSize: this.page.size,
      };
      pointsItemsRoll(params)
        .then((res) => {
          this.tableLoading = false;
          let { code, data, msg } = res;
          if (code === 0) {
            this.tableData = data.records || [];
            this.page.total = data.total || 0;
          } else {
            this.$message.error(msg || "获取列表数据失败");
          }
        })
        .catch(() => {
          this.tableLoading = false;
          this.$message.error("获取服务器数据异常");
        });
    },
    handleVerify(row) {
      this.$confirm("确定核销该券码吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          pointsItemsRollUse({ id: row.id, state: 2 })
            .then((res) => {
              this.tableLoading = false;
              let { code, msg } = res;
              if (code === 0) {
                this.$message.success("核销成功");
                this.getPointsItemsRoll();
              } else {
                this.$message.error(msg || "核销失败");
              }
            })
            .catch(() => {
              this.tableLoading = false;
              this.$message.error("服务器异常，核销失败");
            });
        })
        .catch(() => {
          // 取消核销
        });
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getPointsItemsRoll();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getPointsItemsRoll();
    },
  },
};
</script>

<style scoped lang="scss">
.container {
}
</style>
